import { render, staticRenderFns } from "./FilesPanel.vue?vue&type=template&id=77dc76a4&scoped=true"
import script from "./FilesPanel.vue?vue&type=script&lang=js"
export * from "./FilesPanel.vue?vue&type=script&lang=js"
import style0 from "./FilesPanel.vue?vue&type=style&index=0&id=77dc76a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc76a4",
  null
  
)

export default component.exports